module.exports = new __parcel__URL__("prophylactic-vaccines-icon.158eef44.png").toString();